import { Controller } from "@hotwired/stimulus"

// Cycles light-hearted status messages while a design generates, so the wait
// feels alive. Starts on a random message and rotates on an interval. When the
// design is ready the whole thread frame is replaced, disconnecting this
// controller and clearing the timer.
export default class extends Controller {
  static targets = ["text"]
  static values = {
    messages: Array,
    interval: { type: Number, default: 3500 }
  }

  connect() {
    const messages = this.messagesValue
    if (messages.length === 0) return

    this.index = Math.floor(Math.random() * messages.length)
    this.show(messages)

    this.timer = setInterval(() => {
      this.index = (this.index + 1) % messages.length
      this.show(messages)
    }, this.intervalValue)
  }

  disconnect() {
    if (this.timer) clearInterval(this.timer)
  }

  show(messages) {
    if (this.hasTextTarget) this.textTarget.textContent = messages[this.index]
  }
}
